import { defineStore } from 'pinia'
import { isNil } from 'ramda'
import Vue from 'vue'

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    currentUser: {},
  }),
  getters: {
    currentUserHasRole: (state) => (r) => {
      const roles = state.currentUser.roles
      if (roles) {
        return !isNil(roles.find(role => role === r)) || false
      }
    },
  },
  actions: {
    loadCurrentUser () {
      return Vue.prototype.$httpEZ.get(`/user/current`)
        .then((response) => {
          this.currentUser = response.data
        })
        .catch((error) => {
          throw error
        })
    },
  },
})
